import { faqItems } from '@/mocks/homeData';

export default function FaqSection() {
  return (
    <section id="faq" className="py-10 md:py-14 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2 text-center">常见问题</h2>
          <p className="text-sm text-foreground-500 mb-8 text-center">关于妖精动漫的常见疑问解答</p>

          <div className="space-y-3">
            {faqItems.map((item, i) => (
              <details key={i} className="group border border-background-200/70 rounded-xl bg-background-50">
                <summary className="flex items-center justify-between p-4 md:p-5 cursor-pointer list-none">
                  <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 pr-4">{item.q}</h3>
                  <span className="w-5 h-5 flex items-center justify-center shrink-0 text-foreground-400 group-open:hidden">
                    <i className="ri-add-line" />
                  </span>
                  <span className="w-5 h-5 items-center justify-center shrink-0 text-foreground-400 hidden group-open:flex">
                    <i className="ri-subtract-line" />
                  </span>
                </summary>
                <div className="px-4 md:px-5 pb-4 md:pb-5">
                  <p className="text-sm text-foreground-600 leading-relaxed">{item.a}</p>
                </div>
              </details>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}